import styled, { useTheme } from 'styled-components';
import Modal from '../../../components/Modal';
import Button from '../../../components/Button';
import { useEffect, useState } from 'react';
import {
  BodyLarge,
  ParagraphLargeText,
  ParagraphMediumText,
  TitleMedium,
} from '../../../components/Texts';
import { useSelector } from 'react-redux';
import { selectPrivyToken } from '../../../redux/slices/auth';
import { useGetCurrentUserProfileQuery } from '../../../redux/api/authorized/auth';
import TextInput from '../../../components/Inputs/Text';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../../common/responsive';
import { Share } from '@capacitor/share';
import { Capacitor } from '@capacitor/core';
import { selectThemeMode } from '../../../redux/slices/themeSlice';

const Cashback = ({ onClose }) => {
  const privyToken = useSelector(selectPrivyToken);
  const [referralLink, setReferralLink] = useState('');
  const { data: userData } = useGetCurrentUserProfileQuery(undefined, {
    skip: !privyToken,
  });

  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  const theme = useTheme();

  const themeMode = useSelector(selectThemeMode);

  useEffect(() => {
    if (userData) {
      setReferralLink(`https://deks.xyz/?rc=${userData?.referralCode}`);
    }
  }, [userData]);

  return (
    <Modal onClose={onClose}>
      <div style={{ display: 'flex', gap: 15, flexDirection: 'column' }}>
        <div style={{ display: 'flex', gap: 12, flexDirection: 'column' }}>
          <ParagraphLargeText
            style={{
              fontWeight: '600',
              textAlign: 'center',
              color: theme.text.title,
            }}
          >
            Earn Cashback
          </ParagraphLargeText>
          <img
            width={'100%'}
            src={
              themeMode === 'light'
                ? '/rewards/cashback.webp'
                : '/rewards/cashback-dark.webp'
            }
            style={
              isMobile
                ? {
                    height: 'calc(100vw * 0.33)',
                  }
                : {}
            }
          />
        </div>
        <BodyLarge style={{ textAlign: 'center' }}>
          Earn 1% casback in Solana and SKR when you spend at real-world shops.
        </BodyLarge>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            fullWidth={isMobile}
            onClick={() => {
              onClose();
            }}
          >
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default Cashback;
